import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import {
  DcSensorValueProperties,
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  SolarStatusProperties,
} from '@vi-iot/client';

import { InstallationFeaturesStore } from '@store';

import { FeaturesDetailsOverlayTypeEnum } from '../installation-overlay.model';

@Component({
  selector: 'app-solar',
  templateUrl: './solar.component.html',
  styleUrls: ['./solar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SolarComponent implements OnInit {
  readonly featurePropertyKey = FeaturePropertyKey;
  solarPumps$: Observable<Feature<SolarStatusProperties, never>>;
  solarCollectorTemperature$: Observable<Feature<DcSensorValueProperties, never>>;
  solarDhwTemperature$: Observable<Feature<DcSensorValueProperties, never>>;
  solarRechargeSuppression$: Observable<Feature<SolarStatusProperties, never>>;
  availableOverlays = FeaturesDetailsOverlayTypeEnum;

  @Input() deviceSelectId: string;
  @Input() deviceId: string;

  constructor(private installationFeaturesStore: InstallationFeaturesStore) {}

  ngOnInit(): void {
    this.solarPumps$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.solarPumps,
      this.deviceId
    );
    this.solarCollectorTemperature$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.solarCollectorTemperature,
      this.deviceId
    );
    this.solarDhwTemperature$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.solarDhwTemperature,
      this.deviceId
    );
    this.solarRechargeSuppression$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.solarRechargeSuppression,
      this.deviceId
    );
  }
}
